import React, { useState, useContext } from "react";
import "./Navbar.css";
import logo from "../Assets/logo.png";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../Context/AuthContext";

export const Navbar = () => {
  const { userDetails, logout } = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path) => location.pathname === path;


  const handleLogout = () => {
    logout();
    navigate("/", { replace: true });
  };

  return (
    <>
      <header className="navbar">
        <div className="nav-left">
          <Link to="/" className="logo">
            <img src={logo} alt="Kanha WonderCraft" />
          </Link>
        </div>

        <nav className="nav-links desktop">
          <Link className={isActive("/") ? "active" : ""} to="/">Home</Link>
          <Link className={isActive("/about") ? "active" : ""} to="/about">About Us</Link>
          <Link className={isActive("/toys") ? "active" : ""} to="/toys">Toys</Link>
          <Link className={isActive("/kanhadress") ? "active" : ""} to="/kanhadress">Kanha Dress</Link>
          <Link className={isActive("/giftitems") ? "active" : ""} to="/giftitems">Gift Items</Link>
          {userDetails ? (<Link className={isActive("/userprofile") ? "active" : ""} to="/userprofile">User Profile</Link>) : (<></>)}
          {userDetails ? (<Link className={isActive("/userwishlist") ? "active" : ""} to="/userwishlist">Wishlist</Link>) : (<></>)}
          {userDetails ? (<Link className={isActive("/support") ? "active" : ""} to="/support">Support</Link>) : (<></>)}
        </nav>

        <div className="nav-right desktop">
          {!userDetails ? (
            <Link to="/login" className="login-btn">Login</Link>
          ) : (
            <button className="login-btn" onClick={handleLogout}>Logout</button>
          )}
        </div>

        {/* Mobile Hamburger */}
        <button
          className="hamburger"
          onClick={() => setMenuOpen(true)}
        >
          ☰
        </button>
      </header>

      {/* Mobile Drawer */}
      <div className={`mobile-drawer ${menuOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={() => setMenuOpen(false)}>×</button>

        <Link onClick={() => setMenuOpen(false)} to="/">Home</Link>
        <Link onClick={() => setMenuOpen(false)} to="/about">About Us</Link>
        <Link onClick={() => setMenuOpen(false)} to="/toys">Toys</Link>
        <Link onClick={() => setMenuOpen(false)} to="/kanhadress">Kanha Dress</Link>
        <Link onClick={() => setMenuOpen(false)} to="/giftitems">Gift Items</Link>
        {userDetails ? (<Link onClick={() => setMenuOpen(false)} to="/userprofile">User Profile</Link>) : (<></>)}
        {userDetails ? (<Link onClick={() => setMenuOpen(false)} to="/userwishlist">Wishlist</Link>) : (<></>)}
        {userDetails ? (<Link onClick={() => setMenuOpen(false)} to="/support">Support</Link>) : (<></>)}
        {!userDetails ? (
          <Link onClick={() => setMenuOpen(false)} to="/login" className="drawer-login">Login</Link>
        ) : (
          <button onClick={handleLogout} className="drawer-login">Logout</button>
        )}



      </div>

      {menuOpen && <div className="backdrop" onClick={() => setMenuOpen(false)} />}
    </>
  );
};
